<template>
  <div class="login-bg">
    <div class="box">
      <div class="login-title">户外光后台管理系统</div>
      <div>
        <div class="login-form">
          <h2 class="login-form-title">欢迎登陆</h2>
          <el-form :model="loginForm" ref="loginForm" :rules="rules" hide-required-asterisk>
            <el-form-item prop="username">
              <div class="as login-input-warp">
                <div class="login-icon">
                  <img src="@/assets/login/user.png"/>
                </div>
                <div>
                  <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="password">
              <div class="as login-input-warp">
                <div class="login-icon">
                  <img src="@/assets/login/password.png" alt="" />
                </div>
                <div>
                  <el-input v-model="loginForm.password" @keyup.enter.native="submitFun('loginForm')" type="password" placeholder="请输入密码"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="verify">
                <div class="as login-input-warp">
                  <div class="login-icon">
                    <img src="@/assets/login/verifycode.png" alt="" />
                  </div>
                  <div class="verify-input">
                    <el-input v-model="loginForm.captcha" placeholder="请输入验证码" @keyup.enter.native="submitFun('loginForm')"></el-input>
                  </div>
                </div>
                <div class="verify-code">
                  <img class="captacha" :src="captachaUrl" @click="getCaptcha" v-show="captachaUrl"/>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="checkbox-item">
              <el-checkbox v-model="rememberPsw">记住密码</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" @click="submitFun('loginForm')">登 录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>
    <div class="login-footer">
      <div>© 2026 版权所有</div>
      <div style="margin-top:6px;">
        <a href="https://beian.miit.gov.cn" target="https://beian.miit.gov.cn" style="color:#000000;text-decoration:none;">渝ICP备2024038295号‑1</a >
      </div>
    </div>
  </div>

</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  name: "Login",
  data() {
    return {
      //验证码地址
      captachaUrl: "",
      //表单参数值
      loginForm: {
        username: "",
        password: "",
        captcha: ""
      },
      //表单验证规则
      rules: {
        username: [{
          required: true,
          message: "请输入登录账号",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入登录密码",
          trigger: "blur"
        }],
        captcha: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }]
      },
      //是否记住密码
      rememberPsw: false
    }
  },
  methods: {
    //登录提交
    submitFun: function(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //登录
          this.loginFun()
        } else {
          //验证不通过时阻止提交
          return false
        }
      })
    },
    //登录请求
    loginFun: function() {
      //验证通过，提交登录
      this.$axios({
        method: "post",
        url: "/login/login",
        data: this.$qs.stringify({
          username: this.encrypt(this.loginForm.username),
          password: this.encrypt(this.loginForm.password),
          captcha: this.loginForm.captcha
        })
      }).then(response => {
        //存储用户信息
        sessionStorage.setItem("user", JSON.stringify(response))
        //成功提示
        this.$message.success("登录成功")
        //记住密码
        this.resetLocPassword()
        //跳转页面
        this.$router.push("/main")
      }).catch(() => {
        //更新验证码
        this.getCaptcha();
      })
    },
    //验证码
    getCaptcha: function() {
      this.$axios.get("/login/captcha", { responseType: "blob" }).then(response => {
        this.captachaUrl = window.URL.createObjectURL(response.data)
      })
    },
    //记住密码
    resetLocPassword: function(){
      if(this.rememberPsw) {
        //记住密码
        localStorage.setItem('rememberPsw', this.rememberPsw)
        localStorage.setItem('username', this.loginForm.username)
        localStorage.setItem('password', this.loginForm.password)
      } else {
        localStorage.removeItem('rememberPsw')
        localStorage.removeItem('username')
        localStorage.removeItem('password')
      }
    },
    //初始化操作
    init: function(){
      this.rememberPsw = localStorage.getItem('rememberPsw') == 'true'
      if(this.rememberPsw) {
        this.loginForm.username = localStorage.getItem('username')
        this.loginForm.password = localStorage.getItem('password')
      }
    },
    //加密数据
    encrypt: function(data){
      //数据为空
      if(!data){
        return data
      }
      //密匙
      let key = CryptoJS.enc.Utf8.parse("jymy2023hdlfhgut")
      //加密
      return CryptoJS.AES.encrypt(data, key, {
        iv: CryptoJS.enc.Utf8.parse("a0947djglkcvnf2q"),  //偏移量
        mode: CryptoJS.mode.CBC,      //加密模式
        padding: CryptoJS.pad.Pkcs7   //填充方式
      }).toString()
    }
  },
  mounted() {
    //初始加载验证码
    this.getCaptcha()
    this.init()
  }
}
</script>

<style>
.login-bg {
  height: 100%;
  background-image: url("../../assets/login/login.jpg");
  background-size: 100% 100%;
}

.box {
  width: 500px;
  text-align: center;
  position: absolute;
  top: 43%;
  left: 20%;
  transform: translateY(-50%);
}

.login-title {
  color: #0f3883;
  font-size: 36px;
  margin-bottom: 30px;
}

.login-form {
  width: 482px;
  height: 482px;
  padding: 35px 70px;
  background-color: rgba(117, 160, 189, 0.75);
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 10px;
}

.login-form-title {
  margin: 0 0 25px;
  color: #4d6ba3;
  font-weight: normal;
  font-size: 35px;
  text-align: center;
}

.login-input-warp {
  border: 1px solid #9dcae1;
  border-radius: 3px;
}

.login-icon {
  width: 46px;
  height: 45px;
  padding-right: 6px;
  text-align: center;
  position: relative;
}

.login-icon::after {
  display: inline-block;
  width: 2px;
  height: 20px;
  content: "20B";
  font-size: 0;
  position: absolute;
  right: 9px;
  top: 14px;
  background: #0071d4;
}

.login-icon img {
  margin-top: 8px;
}

.el-form-item {
  margin-bottom: 28px;
}

.login-form .el-input__inner {
  height: 45px;
  line-height: 45px;
  padding-left: 0;
  background-color: transparent;
  border: transparent;
  font-size: 16px;
  color: #506893;
}

.login-form .el-form-item__content {
  line-height: 20px;
}

.el-checkbox__label {
  font-size: 16px;
  color: #506893;
}

.el-input__inner::-webkit-input-placeholder {
  color: #d8d8db !important;
  opacity: 0.8;
}

.el-input__inner::-moz-placeholder {
  color: #d8d8db !important;
  opacity: 0.8;
}

.login-form ::v-deep .el-input__inner::-moz-placeholder {
  color: #d8d8db !important;
  opacity: 0.8;
}

v-deep .el-input__inner::-ms-input-placeholder {
  color: #d8d8db !important;
  opacity: 0.8;
}

.el-checkbox__inner {
  background-color: transparent;
  border-color: #506893;
}

.login-form .login-btn {
  width: 100%;
  height: 44px;
  font-size: 22px;
  background: #3595cd;
  border-color: #788dcc;
  color: #111;
}

.login-form .login-btn:hover {
  color: #333;
  border-color: #9dcae1;
}

.verify {
  position: relative;
}

.verify-code {
  display: inline-block;
  width: 150px;
  height: 47px;
  position: absolute;
  right: 0;
  top: 0;
}

.captacha {
  width: 100%;
  height: 100%;
}

.checkbox-item {
  text-align: left;
}

input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
  -webkit-text-fill-color: #506893 !important;
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
}

input {
  background-color: transparent;
}

/* 底部版权信息样式 */
.login-footer {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 13px;
  color:#000000;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue